//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import Theme from "@/listing-app/mixins/Theme";
import Property from "./grid/Property";

export default {
  name: "Grid",
  data() {
    return {
      empty: false,
    };
  },
  mixins: [Theme],
  components: {
    appProperty: Property,
  },
  props: ["data", "footer"],
  computed: {
    ...mapGetters(["read"]),
    properties() {
      let props = [];
      let selected = { ...this.read("filters") };

			//filter through multi selects first
      props = this.data.filter((prop) => {
        let filtered = true;
        Object.keys(selected).forEach((key) => {
          if (Array.isArray(selected[key])) {
            if (selected[key][0].value !== null) {
              filtered = selected[key].some((multi) => prop.Filters[key].includes(multi.value));
            }
          }
        });

        return filtered;
      });

			// then filter through priceMax and other filters
      props = props.filter((prop) => {
        let filtered = true;

        Object.keys(selected).forEach((key) => {
					if (Array.isArray(selected[key])) return;
					
          if (key == "PriceMax") {
            if (prop.MinPrice > parseInt(selected[key].value)) {
              filtered = false;
            }
          } else if (selected[key].value !== null) {
            if (!prop.Filters[key].includes(selected[key].value)) {
              filtered = false;
            }
          }
        });

        return filtered;
      });

      if (props.length) {
        this.empty = false;
      } else {
        this.empty = true;
      }

      this.set({ muta: "totalResults", data: Object.keys(props).length });

      return props;
    },
  },
  methods: {
    ...mapActions(["set"]),
  },
};
